<template>
  <el-dialog title="详情" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-descriptions :column="1">
      <el-descriptions-item label="推送类型">{{orderStatus(form.code)}}</el-descriptions-item>
      <el-descriptions-item label="订单单号">{{form.orderNumber}}</el-descriptions-item>
      <el-descriptions-item label="推送名称">{{form.title}}</el-descriptions-item>
      <el-descriptions-item label="账套名称">{{form.cityName}}</el-descriptions-item>
      <el-descriptions-item label="推送摘要">{{form.summary}}</el-descriptions-item>
      <el-descriptions-item label="推送时间">{{getPushTime()}}</el-descriptions-item>
      <el-descriptions-item label="推送Code">{{getPushCode()}}</el-descriptions-item>
      <el-descriptions-item label="推送状态">
        <el-tag type="" effect="dark" v-if="form.state === 1" size="mini">推送成功</el-tag>
        <el-tag type="danger" effect="dark" v-else-if="form.state === 2" size="mini">推送失败</el-tag>
        <el-tag type="info" effect="dark" v-else size="mini">待推送</el-tag>
      </el-descriptions-item>
    </el-descriptions>
    <template v-if="sendLog">
      <el-descriptions :column="3">
        <el-descriptions-item label="凭证编码">{{sendLog.dto && sendLog.dto.ExternalCode}}</el-descriptions-item>
        <el-descriptions-item label="凭证日期"> {{formatDate(sendLog.dto && sendLog.dto.VoucherDate)}}</el-descriptions-item>
        <el-descriptions-item label="城市公司"> {{form.sendLog && form.sendLog.cityCompanyName}}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="sendLog.dto && sendLog.dto.Entrys">
        <el-table-column label="科目" prop="Account.Code" align="center" />
        <el-table-column label="金额" prop="AmountCr" align="center" />
        <el-table-column label="客户编码" prop="AuxInfos.AuxAccCustomer.Code" align="center" />
        <el-table-column label="备注" prop="Summary" align="center" />
      </el-table>
    </template>
    <template v-if="sendLog1">
      <el-descriptions :column="3">
        <el-descriptions-item label="凭证编码">{{sendLog1.dto && sendLog1.dto.ExternalCode}}</el-descriptions-item>
        <el-descriptions-item label="凭证日期"> {{formatDate(sendLog1.dto && sendLog1.dto.VoucherDate)}}</el-descriptions-item>
        <el-descriptions-item label="城市公司"> {{form.sendLog1 && form.sendLog1.cityCompanyName}}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="sendLog1.dto && sendLog1.dto.Entrys">
        <el-table-column label="科目" prop="Account.Code" align="center" />
        <el-table-column label="金额" prop="AmountCr" align="center" />
        <el-table-column label="客户编码" prop="AuxInfos.AuxAccCustomer.Code" align="center" />
        <el-table-column label="备注" prop="Summary" align="center" />
      </el-table>
    </template>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
export default {
  data() {
    return {
      form: {},
      formVisible: false,
      formRules: {
      },
      sendLog: null,
      sendLog1: null,
    }
  },
  created() {

  },
  computed: {
    orderStatus() {
      return function (val) {
        switch (val) {
          case '1':
            return "订单";
            break;
          case '2':
            return "充值";
            break;
          case '3':
            return "会议";
            break;
          case '4':
            return "升级身份";
            break;
          case '5':
            return "课程订单";
            break;
          case '7':
            return "售后补差价";
            break;
          case '201':
            return "现金支付取消订单到余额";
            break;
          case 'tuihuosongyue':
            return "退货到余额";
            break;
          case 'tuihuosongxiaodubi':
            return "退货到零售价";
            break;
          case 'quxiaodingdantuihuiyue':
            return "使用余额支付后取消订单退回余额";
            break;
          case 'quxiaodingdantuihuiXDB':
            return "使用零售价支付后取消订单退回零售价";
            break;
          case 'quxiaodingdantuihuiZS':
            return "使用赠送账户支付后取消订单退回赠送账户";
            break;
          case 'kaidanshiyongyue':
            return "使用余额支付订单";
            break;
          case 'kaidanshiyongxiaodubi':
            return "使用零售价支付订单";
            break;
          case 'kaidanshiyongZS':
            return "使用赠送账户支付订单";
            break;
          case 'shengjisongZS2':
            return "使用凭证升级赠送学费账户";
            break;
          case 'chongzhisongxiaodubiXXCZ':
            return "使用凭证充值送零售价";
            break;
          case 'xianxiachongzhisongyueXXCZ':
            return "使用凭证充值后入账余额账户";
            break;
          case 'houtai_daoruyue':
            return "旧系统账户导入余额";
            break;
          case 'chognzhisongxiaodubi':
            return "在线充值送零售价";
            break;
          case 'houtai_daoruxiaodubi':
            return "旧系统账户导入零售价";
            break;
          case 'houtai_daoruxuefei':
            return "旧系统账户导入学费";
            break;
          default:
            return "类型错误";
            break;
        }
      }

    }
  },
  methods: {
    handleUpdate(row) {
      this.form = { ...row }
      this.sendLog = row.sendLog && row.sendLog.requestParameter ? JSON.parse(row.sendLog.requestParameter) : null;
      this.sendLog1 = row.sendLog1 && row.sendLog1.requestParameter ? JSON.parse(row.sendLog1.requestParameter) : null;
      this.formVisible = true
    },
    formatDate(date) {
      if (!date) return ''
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
    /**
     * 从requestParameter中解析推送时间
     */
    getPushTime() {
      try {
        if (this.form.requestParameter) {
          const requestData = JSON.parse(this.form.requestParameter)
          if (requestData.dto && requestData.dto.Entrys && requestData.dto.Entrys.length > 0) {
            const entry = requestData.dto.Entrys[0]
            if (entry.AuxInfos && entry.AuxInfos.length > 0) {
              const bizDate = entry.AuxInfos[0].BizDate
              if (bizDate) {
                return this.formatDate(bizDate)
              }
            }
          }
        }
        return this.formatDate(this.form.createdTime) || ''
      } catch (error) {
        console.error('解析推送时间失败:', error)
        return this.formatDate(this.form.createdTime) || ''
      }
    },
    /**
     * 从requestParameter中解析推送Code
     */
    getPushCode() {
      try {
        if (this.form.requestParameter) {
          const requestData = JSON.parse(this.form.requestParameter)
          if (requestData.dto && requestData.dto.Entrys && requestData.dto.Entrys.length > 0) {
            // 获取所有Entrys的Code
            const codes = requestData.dto.Entrys.map(entry => {
              if (entry.Account && entry.Account.Code) {
                return entry.Account.Code
              }
              return null
            }).filter(code => code !== null)
            
            // 如果有多个Code，用逗号分隔显示
            if (codes.length > 0) {
              return codes.join(', ')
            }
          }
        }
        return this.form.jiecode || ''
      } catch (error) {
        console.error('解析推送Code失败:', error)
        return this.form.jiecode || ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
